export default {
      id: "visibility-hide-usage",
      viewBox: "0 0 24 12",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#visibility-hide",
      toString: function () {
        return this.url;
      }
    }